export const GLOBAL_SEARCH_MFE_PRODUCTION_URL =
    'https://unpkg.servicetitan.com/@servicetitan/global-search-bar';
